'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Uniform = require('../../Uniform');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ReactionDetailsModal = require('../ReactionDetailsModal');

var _ReactionDetailsModal2 = _interopRequireDefault(_ReactionDetailsModal);

var _propTypes = require('../../../shared/prop-types');

var spt = _interopRequireWildcard(_propTypes);

require('./_reactions.scss');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable react/no-multi-comp */


var DEFAULT_PREVIEW_MESSAGE = 'See who reacted to this.';
var EMPHASIS_STYLE_ID = 2;
var EMPHASIS_CLASS_NAME = 'emphasis';

var getPreviewMessage = function getPreviewMessage(reactionMessageParts) {
  return reactionMessageParts.map(function (_ref, index) {
    var message = _ref.message,
        style = _ref.style;

    var messageComponentClassName = (0, _classnames2.default)(_defineProperty({}, EMPHASIS_CLASS_NAME, style === EMPHASIS_STYLE_ID));

    return _react2.default.createElement(
      'span',
      { className: messageComponentClassName, key: index },
      message
    );
  });
};

var ReactionDetails = function (_Component) {
  _inherits(ReactionDetails, _Component);

  function ReactionDetails() {
    _classCallCheck(this, ReactionDetails);

    return _possibleConstructorReturn(this, (ReactionDetails.__proto__ || Object.getPrototypeOf(ReactionDetails)).apply(this, arguments));
  }

  _createClass(ReactionDetails, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Uniform.Text,
        { level: 'small', className: 'reaction-details' },
        _react2.default.createElement(
          'a',
          { className: 'uni-link--implied reaction-details-preview', href: '#', onClick: this.props.onClickPreview },
          Object.keys(this.props.reactionMessageParts).length ? getPreviewMessage(this.props.reactionMessageParts) : DEFAULT_PREVIEW_MESSAGE
        ),
        _react2.default.createElement(_ReactionDetailsModal2.default, {
          communityContentIdObject: this.props.communityContentIdObject,
          logData: this.props.logData,
          onCloseModal: this.props.onCloseModal,
          showModal: this.props.showModal
        })
      );
    }
  }]);

  return ReactionDetails;
}(_react.Component);

ReactionDetails.propTypes = {
  communityContentIdObject: spt.CommunityContentId.isRequired,
  logData: _react.PropTypes.object.isRequired,
  onClickPreview: _react.PropTypes.func.isRequired,
  onCloseModal: _react.PropTypes.func.isRequired,
  reactionMessageParts: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    message: _react.PropTypes.string.isRequired,
    style: _react.PropTypes.number.isRequired
  })).isRequired,
  showModal: _react.PropTypes.bool.isRequired
};
ReactionDetails.defaultProps = {
  logData: {}
};
exports.default = ReactionDetails;